// import moment from 'moment'
// import 'moment/locale/pt-br'
export default {
  pedidosReport (state) {
    return state.pedidosReport
  },
  statusOrder (state) {
    return state.statusOrder
  },
  fornecedores (state) {
    return state.business
  },
  statusName (state) {
    const status = state.statusOrder.map(elem => {
      return elem.name
    })
    return status
  },
  fornecedoresDescription (state) {
    const fornecedores = state.business.map(elem => {
      return elem.name
    })
    return fornecedores
  }
}



// WEBPACK FOOTER //
// ./src/store/relatorios/getters.js